
import { Component, ElementRef, Input } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
//import { SiriusDialogAction } from '@ibtech/sirius-angular-dialog'
import { KvkkPopupModel } from './kvkkPopup.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Action } from 'rxjs/internal/scheduler/Action';

declare const $: any;

@Component({
    selector: 'kvkk-popup',
    templateUrl: './kvkkPopup.component.html',
    styleUrls: ['./kvkkPopup.component.css'],
})

export class KvkkPopupComponent extends SiriusBaseComponent<KvkkPopupModel>  {
    kvkkMessage: any;
    kvkkTitle: any;
    public isOpen: boolean = false;
    public closeEvent: any;
    @Input() kvkkTextIn: string;
    @Input() kvkkTitleIn: string;


    constructor(private el: ElementRef, private domSanitizer: DomSanitizer) {
        super();

    }

    OnInit() {
    }

   // public onActionClick(e: SiriusDialogAction) {
  //TODO:
  public onActionClick( ) {

        //if (e.commandName == 'ok') {
        //    this.isOpen = false;
        //}
    }

    //close popup
    public close() {
        this.isOpen = false;
        $('html').removeClass('dont-move-back');
        if (this.closeEvent) {
            this.closeEvent();
        }
    }

    public open(title: any, content: any) {
        this.kvkkTitle = title;
        this.kvkkMessage = this.domSanitizer.bypassSecurityTrustHtml(content);
        $('html').addClass('dont-move-back');
        this.isOpen = true;
    }

    public setTitleAndMessage(title: string, message: string) {
        this.kvkkTitle = title;
        this.kvkkMessage = this.domSanitizer.bypassSecurityTrustHtml(message); 
    }
}
